import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  leftPanelResetCounter: 0,
  rightPanelResetCounter: 0,
};

const encounterResetSlice = createSlice({
  name: "resetCounter",
  initialState,
  reducers: {
    leftPanelReset: (state) => {
      state.leftPanelResetCounter += 1;
    },
    rightPanelReset: (state) => {
      state.rightPanelResetCounter += 1;
    },
  },
});

export const { leftPanelReset, rightPanelReset } = encounterResetSlice.actions;

export default encounterResetSlice.reducer;
